import { Link } from '@backstage/core-components';
import { Icon } from '@iconify/react';
import { CircleButton } from '@ipen-portal/plugin-common-react';

export const MonitoringHeaderButtons = () => (
  <>
    <CircleButton
      component={Link}
      title="Concept"
      to="/docs/default/domain/ipen-domain/architecture/08_concepts/kpis/"
    >
      <Icon icon="heroicons-outline:light-bulb" />
    </CircleButton>
    <CircleButton
      component={Link}
      title="Development Documentation"
      to="/catalog/default/system/ipen-service-platform/docs/dev-ops/service-observation/how-tos/use-isp/add-kpi/"
    >
      <Icon icon="material-symbols:help-outline" />
    </CircleButton>
  </>
);
